/** Created by azhou on 2019/4/1.*/
<template>
  <ul class="list-item">
    <li class="w-50 list-item-col">{{Itemize.title}} [{{Itemize.type | formatVar(style)}}]</li>
    <li class="w-50 list-item-col flex-column">
      <div v-if="$route.query.type == 8">
        <div>门市价：&yen; {{Itemize.rack_rate_1}}</div>
        <div>采购商价：&yen; {{Itemize.travel_price_1}}</div>
        <div>订单雨价：&yen; {{Itemize.fc_price_1}}</div>
      </div>
      <div v-else>
        <div>&yen; {{Itemize.group_price_0}}（非周末）</div>
        <div>&yen; {{Itemize.group_price_1}}（周末）</div>
      </div>
    </li>
    <li class="w-50 list-item-col flex-column">
      <div v-if="$route.query.type == 8">
        <div>门市价：&yen; {{Itemize.rack_rate_0}}</div>
        <div>采购商价：&yen; {{Itemize.travel_price_0}}</div>
        <div>订单雨价：&yen; {{Itemize.fc_price_0}}</div>
      </div>
      <div v-else>
        <div>&yen; {{Itemize.it_price_0}}（非周末）</div>
        <div>&yen; {{Itemize.it_price_1}}（周末）</div>
      </div>
    </li>
    <li class="w-50 list-item-col">{{Itemize.total_1}} 间</li>
    <li class="w-50 list-item-col">{{Itemize.area}} m²</li>
    <li class="w-50 list-item-col">{{Itemize.feature}}</li>
    <li class="w-50 list-item-col">已上传
      <span class="text-link" @click="showPic"> {{Itemize.pic ? Itemize.pic.split(',').length : 0}}</span> 张</li>
  </ul>
</template>

<script>

  export default {
    name: 'ItemizeRoom',
    props:{
      Itemize:{}
    },
    computed: {
      style () {
        switch (this.$route.query.type) {
          case '8': return 'brandroomStyle'; break;
          default: return 'roomStyle';
        }
      }
    },
    methods:{
      showPic() {
        if (!this.Itemize.pic) return;
        this._CarouselView({
          currentImg: 0,
          picArray: this.Itemize.pic.split(',')
        })
      }
    }
  }
</script>
